<script setup lang="ts">
/**
 * Shared busy overlay — one fixed-size dual-ring spinner only.
 * Stays mounted; toggles via class so enter/leave never flash a gap.
 */
import { useI18n } from 'vue-i18n'
import HrLoadingSpinner from '@/shared/components/HrLoadingSpinner.vue'

const props = withDefaults(
  defineProps<{
    show?: boolean
    labelKey?: string
  }>(),
  {
    show: false,
    /** Prefer caller label; loading/search overlays pass common.loading. */
    labelKey: 'common.loading',
  },
)

const { t } = useI18n()
</script>

<template>
  <div
    class="form-screen-loading"
    :class="{ 'form-screen-loading--visible': props.show }"
    :aria-hidden="props.show ? undefined : 'true'"
    role="alert"
    :aria-busy="props.show || undefined"
    aria-live="polite"
  >
    <div v-if="props.show" class="form-screen-loading__panel">
      <HrLoadingSpinner size="lg" class="form-screen-loading__spinner" />
      <span class="form-screen-loading__label">{{ t(props.labelKey) }}</span>
    </div>
  </div>
</template>
